import { useEffect } from "react";
import { useRouter } from "@tanstack/react-router";
import { recordVisit } from "@/lib/recent-activity";

/**
 * Mounted once in __root. Subscribes to router state and records every
 * navigation whose pathname is in the TRACKED_PATHS catalog.
 */
export function RecentActivityTracker() {
  const router = useRouter();

  useEffect(() => {
    // Record the initial path
    recordVisit(router.state.location.pathname);
    const unsub = router.subscribe("onResolved", ({ toLocation }) => {
      recordVisit(toLocation.pathname);
    });
    return () => unsub();
  }, [router]);

  return null;
}
